import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { parseErrorDetail } from "../lib/api";

export default function ChangePasswordPage() {
  const { user, changePassword, sessionState } = useAuth();
  const nav = useNavigate();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPw !== confirmPw) { setError("New passwords do not match."); return; }
    if (newPw.length < 12) { setError("New password must be at least 12 characters."); return; }
    if (oldPw === newPw) { setError("New password must differ from your current password."); return; }
    setSubmitting(true);
    try {
      const res = await changePassword(oldPw, newPw, confirmPw);
      if (res?.must_relogin) {
        // R6 — server revoked all sessions; force fresh login.
        nav("/login", { replace: true, state: { pwChanged: true } });
        return;
      }
      nav(user?.role === "OWNER_ADMIN" ? "/admin" : "/portal", { replace: true });
    } catch (err) {
      setError(parseErrorDetail(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="apwo-auth-shell">
      <div className="apwo-auth-card" data-testid="change-password-card">
        <header className="apwo-auth-header">
          <p className="apwo-brand-eyebrow">AUTOPARTSB2B</p>
          <h1 className="apwo-auth-title">Set a new password</h1>
          <p className="apwo-auth-sub">
            {sessionState === "AWAITING_PW_CHANGE"
              ? "Your temporary password worked. Please set a new password before continuing."
              : "Choose a strong password. Existing sessions on this account will be signed out."}
          </p>
        </header>

        <form className="apwo-auth-form" onSubmit={onSubmit} noValidate data-testid="change-password-form">
          <label className="apwo-field">
            <span>Current or temporary password</span>
            <input type="password" autoComplete="current-password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} required data-testid="cpw-old" />
          </label>
          <label className="apwo-field">
            <span>New password (minimum 12 characters)</span>
            <input type="password" autoComplete="new-password" value={newPw} onChange={(e) => setNewPw(e.target.value)} required minLength={12} data-testid="cpw-new" />
          </label>
          <label className="apwo-field">
            <span>Confirm new password</span>
            <input type="password" autoComplete="new-password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} required minLength={12} data-testid="cpw-confirm" />
          </label>
          {error && <div className="apwo-alert-error" role="alert" data-testid="cpw-error">{error}</div>}
          <button type="submit" className="apwo-btn-primary" disabled={submitting || !oldPw || !newPw || !confirmPw} data-testid="cpw-submit">
            {submitting ? "Saving…" : "Save new password"}
          </button>
        </form>
      </div>
    </div>
  );
}
